import {Box} from "@mui/system";
import RemoveCustomFieldEntry from "./RemoveCustomFieldEntry";
import {useSelector} from "react-redux";

export default function CustomFieldItem({customField}) {
    const deleteCustomFieldsLoading = useSelector(state => state.customField.deleteCustomFieldsLoading);
    const selectedCustomField = useSelector(state => state.customField.selectedCustomField);

    return (
        <Box sx={style.detailsContainer}>
            <Box sx={style.detailsHeader}>
                <Box>{customField?.name}</Box>
                <Box sx={{}}>
                    <RemoveCustomFieldEntry
                        customFieldId={customField?.id}
                        selectedCustomField={selectedCustomField}
                        loading={deleteCustomFieldsLoading}
                    />
                </Box>
            </Box>
        </Box>
    )
}

const style = {
    detailsContainer: {
        border: '1px solid #b6bebf',
        backgroundColor: '#F8F9F9',
        borderRadius: '10px',
        overflow: 'hidden',
        px: '13px',
        py: '10px',
        mt: '10px',
    },
    detailsHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
}